/*
 * Copyright (c) 2020.  Sanish Manandhar
 * All Rights Reserved
 */
export const TASK_CLEAN_REQUEST = 'TASK_CLEAN_REQUEST';
export const SINGLE_TASK_CLEAN_REQUEST = 'SINGLE_TASK_CLEAN_REQUEST';
export const TASK_ERRORS_CLEAN_REQUEST = 'TASK_ERRORS_CLEAN_REQUEST';

export const TASK_FETCH_REQUEST = 'TASK_FETCH_REQUEST';
export const TASK_FETCH_REQUEST_SUCCESS = 'TASK_FETCH_REQUEST_SUCCESS';
export const TASK_FETCH_REQUEST_FAILURE = 'TASK_FETCH_REQUEST_FAILURE';

export const TASK_TITLE_LIST_FETCH_REQUEST = 'TASK_TITLE_LIST_FETCH_REQUEST';
export const TASK_TITLE_LIST_FETCH_REQUEST_SUCCESS = 'TASK_TITLE_LIST_FETCH_REQUEST_SUCCESS';
export const TASK_TITLE_LIST_FETCH_REQUEST_FAILURE = 'TASK_TITLE_LIST_FETCH_REQUEST_FAILURE';

export const TASK_UPSERT_REQUEST = 'TASK_UPSERT_REQUEST';
export const TASK_UPSERT_REQUEST_SUCCESS = 'TASK_UPSERT_REQUEST_SUCCESS';
export const TASK_UPSERT_REQUEST_FAILURE = 'TASK_UPSERT_REQUEST_FAILURE';

export const SINGLE_TASK_UPSERT_REQUEST = 'SINGLE_TASK_UPSERT_REQUEST';
export const SINGLE_TASK_UPSERT_REQUEST_SUCCESS = 'SINGLE_TASK_UPSERT_REQUEST_SUCCESS';
export const SINGLE_TASK_UPSERT_REQUEST_FAILURE = 'SINGLE_TASK_UPSERT_REQUEST_FAILURE';

export const SINGLE_TASK_FETCH_REQUEST = 'SINGLE_TASK_FETCH_REQUEST';
export const SINGLE_TASK_FETCH_REQUEST_SUCCESS = 'SINGLE_TASK_FETCH_REQUEST_SUCCESS';
export const SINGLE_TASK_FETCH_REQUEST_FAILURE = 'SINGLE_TASK_FETCH_REQUEST_FAILURE';

export const TASK_REASSIGN_REQUEST = 'TASK_REASSIGN_REQUEST';
export const TASK_REASSIGN_REQUEST_SUCCESS = 'TASK_REASSIGN_REQUEST_SUCCESS';
export const TASK_REASSIGN_REQUEST_FAILURE = 'TASK_REASSIGN_REQUEST_FAILURE';

export const TASK_SKIP_REQUEST = 'TASK_SKIP_REQUEST';
export const TASK_SKIP_REQUEST_SUCCESS = 'TASK_SKIP_REQUEST_SUCCESS';
export const TASK_SKIP_REQUEST_FAILURE = 'TASK_SKIP_REQUEST_FAILURE';

export const TASK_PARK_REQUEST = 'TASK_PARK_REQUEST';
export const TASK_PARK_REQUEST_SUCCESS = 'TASK_PARK_REQUEST_SUCCESS';
export const TASK_PARK_REQUEST_FAILURE = 'TASK_PARK_REQUEST_FAILURE';

export const SINGLE_TASK_COMPLETE_ALL_REQUEST = 'SINGLE_TASK_COMPLETE_ALL_REQUEST';
export const SINGLE_TASK_COMPLETE_ALL_REQUEST_SUCCESS = 'SINGLE_TASK_COMPLETE_ALL_REQUEST_SUCCESS';
export const SINGLE_TASK_COMPLETE_ALL_REQUEST_FAILURE = 'SINGLE_TASK_COMPLETE_ALL_REQUEST_FAILURE';

export const TASK_LIST_UPSERT_INDEX_REQUEST = 'TASK_LIST_UPSERT_INDEX_REQUEST';
export const TASK_LIST_UPSERT_INDEX_REQUEST_SUCCESS = 'TASK_LIST_UPSERT_INDEX_REQUEST_SUCCESS';
export const TASK_LIST_UPSERT_INDEX_REQUEST_FAILURE = 'TASK_LIST_UPSERT_INDEX_REQUEST_FAILURE';

export const FETCH_SUBTASKS_REQUEST = 'FETCH_SUBTASKS_REQUEST';
export const FETCH_SUBTASKS_REQUEST_SUCCESS = 'FETCH_SUBTASKS_REQUEST_SUCCESS';
export const FETCH_SUBTASKS_REQUEST_FAILURE = 'FETCH_SUBTASKS_REQUEST_FAILURE';

export const FETCH_TASK_BY_IDENTIFICATION_REQUEST = 'FETCH_TASK_BY_IDENTIFICATION_REQUEST';
export const FETCH_TASK_BY_IDENTIFICATION_REQUEST_SUCCESS =
  'FETCH_TASK_BY_IDENTIFICATION_REQUEST_SUCCESS';
export const FETCH_TASK_BY_IDENTIFICATION_REQUEST_FAILURE =
  'FETCH_TASK_BY_IDENTIFICATION_REQUEST_FAILURE';

export const MARK_TASK_UNREAD_REQUEST = 'MARK_TASK_UNREAD_REQUEST';
export const MARK_TASK_UNREAD_REQUEST_SUCCESS = 'MARK_TASK_UNREAD_REQUEST_SUCCESS';
export const MARK_TASK_UNREAD_REQUEST_FAILURE = 'MARK_TASK_UNREAD_REQUEST_FAILURE';
